import { faPen } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

import { UpdateLinkForm } from '~/components/forms/LinkForm';
import { CategoryBreadcrumbs } from '~/components/organisms/Breadcrumbs';
import { useNavigate } from '~/components/utils/Navigation';

export type IUpdateLinkProps = {
  appId: string;
  categoryId: string;
};

export const AppUpdateLinkPage: React.FC<IUpdateLinkProps> = (props) => {
  const { appId, categoryId } = props;
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <>
      <CategoryBreadcrumbs appId={appId} categoryId={categoryId}>
        <FontAwesomeIcon icon={faPen} />
        {t('common.editing')}
      </CategoryBreadcrumbs>

      <UpdateLinkForm
        appId={appId}
        categoryId={categoryId}
        onSuccess={() =>
          // TODO: once the API is ready, navigate to the parent category if
          // the link was moved.
          navigate(`/apps/${appId}/categories`)
        }
        cancelUrl={`/apps/${appId}/categories/${categoryId}`}
      />
    </>
  );
};
